export interface AnalyticDate {
  date: string;
  value: number;
}

export interface AnalyticDimension {
  name: string;
  data: AnalyticDate[];
}

export interface AnalyticMetric {
  metric: AnalyticMetricEnum;
  unit: AnalyticMetricEnum;
  company: string;
  start_date: string;
  end_date: string;
  dimensions: AnalyticDimension[];
}

export enum AnalyticMetricEnum {
  activeUsers = 'activeUsers',
  totalUsers = 'totalUsers',
  sessions = 'sessions',
  sessionSourceMedium = 'sessionSourceMedium',
  deviceCategory = 'deviceCategory',
  averageSessionDuration = 'averageSessionDuration',
  activeUsersPercentage = 'activeUsersPercentage',
  averageSessionDurationPerUser = 'averageSessionDurationPerUser',
  recurringUsers = 'recurringUsers',
  frequencyVisitsAgain = 'frequencyVisitsAgain',
  newUsers = 'newUsers',
  measureMaxUsersEligibility = 'measureMaxUsersEligibility',
  measuresWithNoEligibility = 'measuresWithNoEligibility',
  averageMeasuresPerEligibleUser = 'averageMeasuresPerEligibleUser',
  averageQuestionaryCompletionPercentage = 'averageQuestionaryCompletionPercentage',
  pagePerSession = 'pagePerSession',
  sessionsExcludingMeasureViews = 'sessionsExcludingMeasureViews',
  mostPopularCategories = 'mostPopularCategories',
  outlinkClicks = 'outlinkClicks',
  mostViewed = 'mostViewed',
  userEngagementDuration = 'userEngagementDuration',
}

export interface AnalyticMetricConfig {
  timeSeries: boolean;
  panel: boolean;
  total?: boolean;
  average?: boolean;
  percentage?: boolean;
  time?: boolean;
  table?: boolean;
}

export const AnalyticMetricRecord: Record<
  AnalyticMetricEnum,
  AnalyticMetricConfig
> = {
  [AnalyticMetricEnum.activeUsers]: {
    timeSeries: true,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.totalUsers]: {
    timeSeries: true,
    panel: true,
  },
  [AnalyticMetricEnum.sessions]: {
    timeSeries: true,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.sessionSourceMedium]: {
    timeSeries: false,
    panel: false,
    table: true,
    total: true,
  },
  [AnalyticMetricEnum.deviceCategory]: {
    timeSeries: false,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.averageSessionDuration]: {
    timeSeries: false,
    panel: true,
    average: true,
    time: true,
  },
  [AnalyticMetricEnum.activeUsersPercentage]: {
    timeSeries: false,
    panel: true,
    percentage: true,
  },
  [AnalyticMetricEnum.averageSessionDurationPerUser]: {
    timeSeries: true,
    panel: false,
    percentage: true,
  },
  [AnalyticMetricEnum.recurringUsers]: {
    timeSeries: false,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.frequencyVisitsAgain]: {
    timeSeries: false,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.newUsers]: {
    timeSeries: false,
    panel: false,
    total: true,
  },
  [AnalyticMetricEnum.measureMaxUsersEligibility]: {
    timeSeries: false,
    table: true,
    panel: false,
  },
  [AnalyticMetricEnum.measuresWithNoEligibility]: {
    timeSeries: false,
    table: true,
    panel: false,
  },
  [AnalyticMetricEnum.averageMeasuresPerEligibleUser]: {
    timeSeries: false,
    panel: true,
    average: true,
  },
  [AnalyticMetricEnum.averageQuestionaryCompletionPercentage]: {
    timeSeries: false,
    panel: true,
    percentage: true,
  },
  [AnalyticMetricEnum.pagePerSession]: {
    timeSeries: true,
    panel: true,
    average: true,
  },
  [AnalyticMetricEnum.sessionsExcludingMeasureViews]: {
    timeSeries: false,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.mostPopularCategories]: {
    timeSeries: false,
    panel: false,
    table: true,
    total: true,
  },
  [AnalyticMetricEnum.outlinkClicks]: {
    timeSeries: true,
    panel: true,
    total: true,
  },
  [AnalyticMetricEnum.mostViewed]: {
    timeSeries: false,
    panel: false,
    table: true,
  },
  [AnalyticMetricEnum.userEngagementDuration]: {
    timeSeries: false,
    panel: false,
    table: true,
    average: true,
    time: true,
  },
};
